import { render } from "./PageLogin.vue?vue&type=template&id=c50d74fa"
import script from "./PageLogin.vue?vue&type=script&lang=js"
export * from "./PageLogin.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.25.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__